const checkPassword = (values, translate, errors = {}) => {
  if (values.password) {
    const newPassword = values.password;
    // Contains special char?
    if (!new RegExp(/[^\dA-Z]/i).test(newPassword))
      errors.password = translate('validation.passwdSpecial', {
        _: 'Password must contain a special character',
      });
    // Contains number?
    if (!new RegExp(/\d/).test(newPassword))
      errors.password = translate('validation.passwdNumber', {
        _: 'Password must contain a number',
      });
    // Contains lower case letter?
    if (!new RegExp(/[a-z]/).test(newPassword))
      errors.password = translate('validation.passwdLower', {
        _: 'Password must contain a lowercase character',
      });
    // Contains upper case letter?
    if (!new RegExp(/[A-Z]/).test(newPassword))
      errors.password = translate('validation.passwdUpper', {
        _: 'Password must contain an uppercase character',
      });
    // Is at least 8 chars long?
    if (newPassword.length < 8)
      errors.password = translate('validation.passwdMinLen', {
        _: 'Password must be at least 8 characters',
      });
    // Is at most 99 chars long?
    if (newPassword.length > 99)
      errors.password = translate('validation.passwdMaxLen', {
        _: 'Password must be no more than 99 characters',
      });
  } else {
    errors.password = translate('ra.validation.required');
  }

  return errors;
};

const checkEmail = (values, translate, errors = {}) => {
  if (values.email) {
    const { email } = values;
    if (
      !new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/, 'i').test(
        email.trim()
      )
    )
      errors.email = translate('validation.invalidEmail', {
        _: 'Invalid email format',
      });
  } else {
    errors.email = translate('ra.validation.required');
  }

  return errors;
};

const checkCode = (values, translate, errors = {}) => {
  if (!values.verificationCode)
    errors.verificationCode = translate('ra.validation.required');
  return errors;
};

export const validatePassword = (values, props) => {
  const errors = {};
  const { translate } = props;
  return checkPassword(values, translate, errors);
};

export const validateCodePassword = (values, props) => {
  const errors = {};
  const { translate } = props;
  checkCode(values, translate, errors);
  checkPassword(values, translate, errors);
  return errors;
};

export const validateEmail = (values, props) => {
  const errors = {};
  const { translate } = props;
  return checkEmail(values, translate, errors);
};

export const isNewPasswordRequired = (user = {}) =>
  user.challengeName === 'NEW_PASSWORD_REQUIRED';
